<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    :parentStoreName="parentStoreName"
    :parentUrlKey="parentUrlKey"
    :submit="submit"
    :status="status"
    labelBack="Atrás"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <ValidationProvider
                ref="name"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.name"
                  label="Nombre"
                  prepend-inner-icon="fas fa-file"
                  ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          
          <v-row>
            <v-col>
              <ValidationProvider
                      ref="picture" rules=""
                      v-slot="{ errors }"
              >
                <Upload
                        :error-messages="errors"
                        accept="image/png, image/jpeg, image/jpg"
                        placeholder="Foto"
                        prepend-icon="fas fa-camera"
                        label=""
                        :multiple="false"
                        :onSelectedPicture="onSelectedPicture"
                ></Upload>
                <v-img
                        :src="picture"
                        width="200"
                        style="margin: auto"
                ></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import Upload from "@/components/Upload";
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm, Upload},
    computed: {
      ...mapState({
        status: state => state.Car_colors.status,
      })
    },
    async created() {
      const self = this;
      let filters = {};

      if(this.$route.params.model_id) {
        this.data.model_id = this.$route.params.model_id
        filters.model_id = this.$route.params.model_id
      }
      if(this.$route.params.id) filters.model_id = this.$route.params.id

      await self.$store.dispatch('Car_colors/getListAll',filters);
    },
    data() {
      return {
        parentStoreName: 'Car_brands/'+this.$route.params.brand_id+'/Car_models',
        parentUrlKey:"model_id",
        storeName: 'Car_colors',
        title: "Colores",
        filteredAttributes: ["picture"],
        show1: false,
        picture: "",
        data: {
          name: '',
          model_id: '',
          picture: undefined,
        }
      }
    },  
    methods: {
        onSelectedPicture(file) {
            const self = this;
            this.data.picture = file;

            let fr = new FileReader();
            fr.onload = function () {
                self.picture = fr.result;
            };
            fr.onerror = function () {
                self.picture = '';
            };
            fr.readAsDataURL(this.data.picture);
        }
    },
  }
</script>
